export default __webpack_public_path__ + "static/template_detect-2e99f6be3dd5d3f96af2386ba6c8fe18.png";